<template>
  
  <div class="content">
		<div class="content-c">
			<img class="load-img" src="../assets/images/loading.gif" mode="" />
			<div class="load-text color-9">{{$t('msgLoading')}}</div>
		</div>
	</div>
</template>

<script>
export default {
    data() {
        return {
            code: '',
			type: '',
			state: ''
        }
    },
    created() {

    },
    methods: {
        // 获取url地址参数
        getUrlParam(paraName) {
			let url = window.location.toString();
			let arrObj = url.split('?');
			if (arrObj.length > 1) {
				let arrPara = arrObj[1].split('&');
				let arr;
				for (let i = 0; i < arrPara.length; i++) {
					arr = arrPara[i].split('=');
					if (arr != null && arr[0] == paraName) {
						if (arr[1].indexOf('#')) {
							let str;
							str = arr[1].split('#');
							return str[0];
						}
						return arr[1];
					}
				}
				return '';
			} else {
				return '';
			}
		},
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>